import { Column } from '../common/table/model/table-column';
import { gettext } from '../../../utility/gettext.util.service';

const commonColumnDef = [
  new Column({
    title: gettext('Name'),
    field: 'name',
    sortable: true,
    ascending: true,
  }),
  new Column({
    title: gettext('Make-Model'),
    field: 'makeModel',
    sortable: true,
  }),
  new Column({
    title: gettext('Asset Type'),
    field: 'assetType',
    sortable: true,
  }),
  new Column({
    title: gettext('Cat-Class'),
    field: 'catClass',
    sortable: true,
  }),
];

const lastSeen = new Column({
  title: gettext('Last Seen'),
  field: 'lastSeenAgo',
  width: '200px',
  sortable: true,
  sort(itemA, itemB) {
    const valA = new Date(itemA.coordsAt || 0);
    const valB = new Date(itemB.coordsAt || 0);

    if (this.ascending) return valA > valB ? -1 : 1;
    return valA > valB ? 1 : -1;
  },
});

const onSite = new Column({
  title: gettext('On Site Status'),
  field: 'onSiteStatus',
  sortable: true,
  render: (item) => {
    return `<span style="display:flex;">
              <span style="background-color:${item.onSiteStatusColor};margin: 0.2rem 2rem 0.2rem 0;
                           width: 0.9rem;">
              </span>
              <span>${item.onSiteStatus}</span>
            </span>`;
  },
});

const ccLikeQtyOnSiteUsagePercent = new Column({
  title: gettext('Like qty usage %'),
  field: 'ccLikeQtyOnSiteUsagePercent',
  sortable: true,
});

const ccLikeQtyOnSite = new Column({
  title: gettext('Like qty onsite'),
  field: 'ccLikeQtyOnSite',
  sortable: true,
});

const lastUsed = new Column({
  title: gettext('Last Used'),
  field: 'lastUsedAtAgo',
  width: '200px',
  sortable: true,
  sort(itemA, itemB) {
    const valA = new Date(itemA.usedAt || 0);
    const valB = new Date(itemB.usedAt || 0);

    if (this.ascending) return valA > valB ? -1 : 1;
    return valA > valB ? 1 : -1;
  },
});

const overviewView = {
  name: 'overview',
  label: gettext('Overview'),
  filters: ['seenIn', 'usedIn'],
};

export const inventoryListView = {
  name: 'inventory',
  label: gettext('Total Inventory'),
  columnsDef: [
    ...commonColumnDef,
    ccLikeQtyOnSite,
    ccLikeQtyOnSiteUsagePercent,
    lastSeen,
    onSite,
    lastUsed,
  ],
  filters: ['name', 'make', 'model', 'cat', 'class', 'assetType', 'onSite', 'seenIn', 'usedIn'],
};

export const onSiteAttentionListView = {
  name: 'onsite',
  label: gettext('On Site Attention'),
  columnsDef: [...commonColumnDef, lastSeen, onSite],
  filters: ['name', 'make', 'model', 'cat', 'class', 'assetType', 'seenIn'],
  excludeChart: 'usage',
  preDefineFilter: {
    match(asset) {
      const { onSite, seenIn } = asset || {};
      const actuallyOnsite = onSite && seenIn === 'seenIn3d';

      return !actuallyOnsite;
    },
  },
};

export const usageListView = {
  name: 'usage',
  label: gettext('Usage'),
  columnsDef: [...commonColumnDef, ccLikeQtyOnSite, ccLikeQtyOnSiteUsagePercent, lastUsed],
  filters: ['name', 'make', 'model', 'cat', 'class', 'assetType', 'usedIn'],
  excludeChart: 'onsite',
  preDefineFilter: {
    match(asset) {
      const { onSite, lastReportedUsageIn3d, usedIn } = asset || {};
      const actuallyLowUsage = onSite && lastReportedUsageIn3d && usedIn !== 'usedIn3d';

      return actuallyLowUsage;
    },
  },
};

export default {
  overview: overviewView,
  inventory: inventoryListView,
  onsite: onSiteAttentionListView,
  usage: usageListView,
};
